module.exports = __webpack_public_path__ + "img/up-right.324ae840.svg";